<template>
  <div>
    <c-tab
      type="horizon"
      :tabItems.sync="tabItems"
      :inlineLabel="true"
      v-model="tab"
      :dense="true"
      :height="tabHeight"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :param="popupParam"
          @closePopup="closePopup"
          @insertTraningInfo="updateMode"
          @setRegInfo="setRegInfo"
        />
      </template>
    </c-tab>
  </div>
</template>
<script>
export default {
  name: 'chem-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        sopEmergencyTrainingId: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      tab: 'scenario',
      tabItems: [
        { name: 'scenario', icon: 'info', label: '비상대응훈련 상세', component: () => import(`${'./traningInfo.vue'}`) },
      ],
      addTabItems: [
        { name: 'assess', icon: 'assessment', label: '훈련 평가', component: () => import(`${'./traningAssess.vue'}`) },
      ],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 36);
    },
  },
  methods: {
    init() {
      if (this.popupParam.sopEmergencyTrainingId != '') {
        this.tabItems = this.tabItems.concat(this.addTabItems);
      }
    },
    updateMode(_sopEmergencyTrainingId) {
      this.popupParam.sopEmergencyTrainingId = _sopEmergencyTrainingId;
      // addItems 수정
      if (this.tabItems.length > 1) {
        //
      } else {
        this.tabItems = this.tabItems.concat(this.addTabItems);
      }
    },
    closePopup() {
      this.$emit('closePopup');
    },
    setRegInfo(data) {
      this.$emit('setRegInfo', data)
    }
  }
};
</script>